import xspy from 'xspy'

import { consoleSpy } from './consoleSpy'
import {
  loggingConsoleListeners,
  loggingExceptionListeners,
  loggingNetworkListeners,
} from './listeners'

const loggers = [
  xspy,
  consoleSpy,
  loggingConsoleListeners,
  loggingExceptionListeners,
  loggingNetworkListeners,
]

export const enableLoggingInProductionMode = () => {
  // В режиме production сборки включаем логирование, иначе выключаем. Под production сборкой подразумевается webpack.prod.js, т.е. npm run build
  if (PRODUCTION) {
    loggers.forEach(logger => {
      logger.enable()
    })
  } else {
    loggers.forEach(logger => {
      logger.disable()
    })
  }
  /*TODO: 
  Request URL: http://localhost:83/api/seismic-picker/api/v1/survey2d/import/5201c2ff-eef2-410f-89bf-3b4b72f9048e/profiles/20010310
  Request Method: POST
  Status Code: 204 No Content

  Crashes: XMLHttpRequest: Exception in request handler TypeError: Failed to construct 'Response': Response with null body status cannot have body
  */

  xspy.disable()
}
